import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "engagement--sprite",
  "use": "engagement--sprite-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"engagement--sprite\">\n<path d=\"M2.5 9.00016V13.6668H14.5V12.6668L8.5 8.00016L5.83333 11.6668L2.5 9.00016ZM2.5 5.00016L5.16667 7.00016L8.5 2.3335L11.8333 5.00016H14.5V10.9802L8.23333 6.10683L5.58 9.76016L2.5 7.2935V5.00016Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol